import { render } from "./PaymentMethodForm.vue?vue&type=template&id=0d5203db"
import script from "./PaymentMethodForm.vue?vue&type=script&lang=js"
export * from "./PaymentMethodForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__